import { backendUrl } from './App';
const stellartermApiUrl = 'https://api.stellarterm.com/v1/ticker.json'

const deposit = async (token, stellarAddress, centAmount) => {
	var data = { token, stellarAddress, centAmount };
	console.log('y')
	console.log(token, stellarAddress, centAmount);
	const response = await fetch(backendUrl + "/api/deposit", {
		method: "POST",
		body: JSON.stringify(data),
		headers: new Headers({
			"Content-Type": "application/json"
		})
	});
	console.log('x', response)

	const body = await response.json();
	console.log('a', body)
	
	if (response.status !== 200) throw new Error(body.message);
	console.log('ab')

	if (!body.transactionID) throw new Error('No transactionID returned');
	console.log('abc')
	return body.transactionID
};

const connect = async (authCode) => {
	var data = { authCode };
	const response = await fetch("/api/connect", {
		method: "POST",
		body: JSON.stringify(data),
		headers: new Headers({
			"Content-Type": "application/json"
		})
	});
	const body = await response.json();
	if (response.status !== 200) throw Error(body.message);

	if (!body.reference) throw Error('No withdrawal reference returned');
	if (!body.loginLink) throw Error('No login link returned');
	console.log(body.loginLink)
	return [body.reference, body.loginLink]
};

const getXLMPrice = () => {
  return new Promise((resolve, reject) => {
    fetch(stellartermApiUrl)
			.then(res => {
				return res.json();
			})
      .then((tickerData) => {
        // console.log('stellarterm external prices:', tickerData._meta.externalPrices);
        resolve(tickerData._meta.externalPrices.USD_XLM);
      })
      .catch((err) => {
        console.log(err);
        reject('error occured to get XLM prices');
      })
  });
};

export { deposit, connect, getXLMPrice };
